import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index.jsx"
import Icons from "../../assets/icons/index.jsx"
import { useQuery } from "@apollo/client";
import { GET_ALL_Video, GET_Free_Video } from "../../gql/queries.jsx";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getPercentage, trimText, getTime, getVideoTime, getfreeVideoTime } from "../../utils/index.js";
import NoDataFound from "../common/NoDataFound/NoDataFound.jsx"
import { authorizationCheck, profileCheck } from "../../utils/logout.jsx";
import Loader from "../common/Loader/Loader.jsx";
import Modal from 'react-bootstrap/Modal';
import { decrypt, decryptdata, encrypt } from "../../utils/crypto.jsx";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong.jsx";
import { getCurrent } from "../../restApi/api.js";
import ConnectionError from "../common/NoDataFound/ConnectionError.jsx";
function VideoLayer() {

	const navigate = useNavigate()
	const completePathUrl = useLocation()
	if ((localStorage.getItem('profileDetails')) == 'undefined' || (localStorage.getItem('profileDetails')) == '' || (localStorage.getItem('profileDetails')) == 'null' || localStorage.getItem('profileDetails') == '{}' || decrypt(localStorage.getItem('profileDetails')) == {} || decrypt(localStorage.getItem('profileDetails')) == undefined || decrypt(localStorage.getItem('profileDetails')) == null || decrypt(localStorage.getItem('profileDetails')) == '') {
		localStorage.clear()
		profileCheck(navigate)
	}
	const [version, setVersion] = useState((localStorage.getItem('version') && localStorage.getItem('version') != 'undefined' && localStorage.getItem('version') != "null") ? JSON.parse(localStorage.getItem('version')) : { "show": "4.0", "actual": "400" });
	const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
	const [recommededData, setrecommeded] = useState(false)
	const [show, setShow] = useState(false);
	const [proUserShow, setProUser] = useState(false);
	const packageStatus = JSON.parse(decrypt(localStorage.getItem('packageStatus')))
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const proShowUser = () => setProUser(true);
	const ProUserHide = () => setProUser(false);
	let userProfile = JSON.parse(decrypt(localStorage.getItem('profileDetails')));
	if (!userProfile && !userProfile?.preparingFor) {
		localStorage.clear()
		navigate('/onboarding/login')
	}

	const query1 = useQuery(GET_ALL_Video, {
		variables: {
			"courseName": course?.preparingFor,
			"version": parseInt(version && version?.actual),
			"status": true,
			"contentType": "videos",
			"isRoot": true
		},
	});
	const query2 = useQuery(GET_Free_Video, {
		variables: {
			"courseName": [course?.preparingFor],
			"version": parseInt(version && version?.actual),
			"page": 1,
			"limit": 3
		},
	});
	const currentList = async () => {
		await getCurrent()
			.then(response => {
				return response.json()
			})
			.then(data => {
				let req = JSON.parse(decrypt(data))
				if (req?.data?.code === 1) {
					let user = req.data.result
					const packageStatus = JSON.stringify({ activePackageLength: user?.activePackage?.length, isTrialUser: user?.isTrialUser })
					localStorage.setItem('packageStatus', encrypt(packageStatus))
				} else {
					localStorage.clear()
					navigate('/onboarding/login')
				}
			}).catch((err) => {
				return (<>
					<div className="main_wrapper">
						<div className="col-lg-12">
							<ConnectionError pathName={completePathUrl.pathname} />
						</div>
					</div>
				</>)
			})
	}
	useEffect(() => {
		currentList()
	}, []);
	if (query1.loading || query2.loading) { return (<><Loader /></>) }
	if (query1?.error || query2?.error) {
		if (query1?.error?.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query2?.error?.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
			authorizationCheck(navigate)
		}
		else if (query1?.error?.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') || query2?.error?.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
			return (<>
				<div className="main_wrapper">
					<div className="col-lg-12">
						<SomethingWentWrong pathName={completePathUrl.pathname} />
					</div>
				</div>
			</>)
		}
		else {
			return (<>
				<div className="main_wrapper">
					<div className="col-lg-12">
						<ConnectionError pathName={completePathUrl.pathname} />
					</div>
				</div>
			</>)

		}
		console.log(query1.error.graphQLErrors);
	}

	let resourcelist
	let resourcedata = []
	query1.data && query1.data.layers.map(obj => {
		if (obj.layerType === null) {
			resourcedata.push(obj)
		}
	})

	let videolist
	query1.data && query1.data.layers.map(obj => {
		if (obj.layerType === 'subject_list') {
			videolist = obj.subLayers
			return
		}
	})
	let video
	query1.data && query1.data.layers.map(obj => {
		if (obj.layerType === 'subject_list') {
			video = obj
			return
		}
	})

	let resource
	query1.data && query1.data.layers.map(obj => {
		if (obj.layerType === 'resource_list') {
			resource = obj
			return
		}
	})

	query1.data && query1.data.layers.map(obj => {
		if (obj.layerType === 'resource_list') {
			resourcelist = obj.subLayers
			return
		}
	})





	if (query1.data && query1.data.layers.length === 0 || query1.data && query1.data.layers[0].subLayers.length === 0) {
		return (<>
			<div className="main_wrapper">
				<div className="col-lg-12">
					<NoDataFound />
				</div>
			</div>

		</>)
	}
	return (
		<>
			<div className="main_wrapper">
				<div className="breadcrumbs">
					<ul className="breadcrumb">
						<li className="breadcrumb-item"><a>Home</a></li>
						<li className="breadcrumb-item"><a>Video</a></li>
					</ul>
				</div>
				<section className="videoLayer_wrapper section_side_padding">
					<div className="row">
						<div className="col-lg-8 col-md-7 col-sm-12">
							{
								videolist !== undefined && videolist && videolist.length != 0 &&
								<div className="subjects_wrapper">
									<div className="subjects_header">
										<h6>{video && video.title}</h6>
										<p>{video && video.description}</p>
									</div>
									<div className="all_subjects_name_wrapper">
										<ul type="none" className="subjects_child d-flex flex-wrap">
											{videolist && videolist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
												<li>
													<div className="subject_main_list d-flex align-itmes-center">
														<div className="subject_img_wrap d-flex align-items-center">
															<figure className="subject_img">
																<img src={d.icon} alt="" className="img-fluid" />
															</figure>
															<div className="subject_details">
																<Link to={d._id}>
																	<h6>{d.title}</h6>
																	<p>{d.author ? d.author.name : ''}</p>
																</Link>
															</div>
														</div>
														{
															getPercentage(d) !== 0 &&
															<div className="progressbar_wraper d-flex align-items-center">
																<div className="progress_details">
																	<span>{`${getPercentage(d)}%`}</span>
																	{getPercentage(d) !== 100 &&
																		<div className="progress">
																			<div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
																		</div>

																	}
																	{getPercentage(d) === 100 &&
																		<div className="progress">
																			<div className="progress-bar completed" style={{ width: `${getPercentage(d)}%` }}></div>
																		</div>
																	}
																</div>
																<div className="right_arrow">
																	<img src={Icons.VideoArrow} alt="" className="img-fluid" />
																</div>
															</div>
														}
													</div>
												</li>
											))}
											{/* <li>
										<div className="subject_main_list d-flex align-itmes-center">
											<div className="subject_img_wrap d-flex align-items-center">
												<figure className="subject_img">
													<img src={Icons.Micro} alt="" className="img-fluid" />
												</figure>
												<div className="subject_details">
													<h6>Microbiology</h6>
													<p>Dr.Ashwani Kumar</p>
												</div>
											</div>
											<div className="progressbar_wraper d-flex align-items-center">
												<div className="progress_details">
													<span>40%</span>
													<div className="progress">
														<div className="progress-bar" style={{ width: "30%" }}></div>
													</div>
												</div>
												<div className="right_arrow">
													<img src={Icons.VideoArrow} alt="" className="img-fluid" />
												</div>
											</div>
										</div>
									</li> */}
										</ul>
									</div>
								</div>
							}

							{
								resourcelist && resourcelist.length != 0 &&
								<div className="other_reasource_wrapper">
									<div className="subjects_header">
										<h6>{resource ? resource.title : ''}</h6>
										<p>{resource ? resource.description : ''}</p>
									</div>
									<div className="resource_main">
										<div className="row">
											{resourcelist && resourcelist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
												<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
													<Link to={`otherResource/${d._id}`}>
														<div className="resource_card d-flex">
															<div className="resource_img_detail">
																<figure className="res_img">
																	<img src={d.icon} alt="" className="img-fluid" />
																</figure>
																<h6>{d.title}</h6>
																<p>{trimText(d) ? `${trimText(d)}` : ''}</p>
															</div>
															<div className="res_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div>
														</div>
													</Link>
												</div>
											))}
											{/* <div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res2} alt="" className="img-fluid" />
												</figure>
												<h6>How to Study in 1st Prof</h6>
												<p>Learn how to study in 1st Prof</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res3} alt="" className="img-fluid" />
												</figure>
												<h6>Grand Test Videos</h6>
												<p>Solution videos of all Grand Tests</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res4} alt="" className="img-fluid" />
												</figure>
												<h6>Recall Question Videos</h6>
												<p>Solution videos of all previous year tests</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12">
										<div className="resource_card d-flex">
											<div className="resource_img_detail">
												<figure className="res_img">
													<img src={Images.Res5} alt="" className="img-fluid" />
												</figure>
												<h6>DBMCI Live</h6>
												<p>Recordings of all DBMCI Live sessions</p>
											</div>
											<div className="res_arrow">
												<img src={Icons.VideoArrow} alt="" className="img-fluid" />
											</div>
										</div>
									</div> */}
										</div>
									</div>
								</div>
							}
							{
								resourcedata && resourcedata.length != 0 &&
								<div className="other_reasource_wrapper">
									<div className="subjects_header">
										<h6>All Resources</h6>
										<p>All resource description</p>
									</div>
									<div className="resource_main">
										<div className="row">
											{resourcedata && resourcedata.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
												<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
													<Link to={`otherResource/${d._id}`}>
														<div className="resource_card d-flex">
															<div className="resource_img_detail">
																<figure className="res_img">
																	<img src={d.icon} alt="" className="img-fluid" />
																</figure>
																<h6>{d.title}</h6>
																<p>{trimText(d) ? `${trimText(d)}...` : ''}</p>
															</div>
															<div className="res_arrow">
																<img src={Icons.VideoArrow} alt="" className="img-fluid" />
															</div>
														</div>
													</Link>
												</div>
											))}

										</div>
									</div>
								</div>
							}
							<div className="col-lg-12">
								{
									videolist !== undefined && videolist && videolist.length === 0 && resourcelist && resourcelist.length === 0 && resourcedata && resourcedata.length === 0
								}
							</div>
							{/* <button className="btn btn-success" onClick={proShowUser}>Click me</button> */}
						</div>
						<div className="col-lg-4 col-md-5 col-sm-12" >
							<div className="videos_wrapper">
								{
									recommededData && (
										<div className="recommended_video_wrapper">
											<div className="subjects_header">
												<h6>Recommended Video</h6>
												<div className="view_all_text d-flex align-items-center">
													<div className="main_paragraph">
														<p>Start your learning journey</p>
													</div>
													<div className="view_text">
														<Link to={`/view/all/${video}`}>
															<p><a>View All</a></p>
														</Link>
													</div>
												</div>
											</div>
											<div className="recommend_video_details">
												<ul type="none" className="recommend_list">
													<li>
														<div className="recommend_list_main d-flex align-items-center">
															<figure className="user_img">
																<img src={Images.VideoImg} alt="" className="img-fluid" />
																<figcaption className="free_tag">
																	<span>Free</span>
																</figcaption>
															</figure>
															<div className="recommend_list_content">
																<h6>Cranial Nerve Nuclei and Columns</h6>
																<span className="name_label">Dr.Ashwani Kumar</span>
																<div className="rate_timer">
																	<span>
																		<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
																	</span>
																	<span>
																		<img src={Icons.Clock} alt="Clock" className="img-fluid" /> 01:10:54
																	</span>
																	<span className="play_icn">
																		<img src={Icons.Play} alt="Play" className="img-fluid" />
																	</span>
																</div>
															</div>
														</div>
													</li>
													<li>
														<div className="recommend_list_main d-flex align-items-center">
															<figure className="user_img">
																<img src={Images.VideoImg} alt="" className="img-fluid" />
																<figcaption className="free_tag">
																	<span>Free</span>
																</figcaption>
															</figure>
															<div className="recommend_list_content">
																<h6>Cranial Nerve Nuclei and Columns</h6>
																<span className="name_label">Dr.Ashwani Kumar</span>
																<div className="rate_timer">
																	<span>
																		<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
																	</span>
																	<span>
																		<img src={Icons.Clock} alt="Star" className="img-fluid" /> 01:10:54
																	</span>
																	<span className="play_icn">
																		<img src={Icons.Play} alt="Play" className="img-fluid" />
																	</span>
																</div>
															</div>
														</div>
													</li>
													<li>
														<div className="recommend_list_main d-flex align-items-center">
															<figure className="user_img">
																<img src={Images.VideoImg} alt="" className="img-fluid" />
																<figcaption className="free_tag">
																	<span>Free</span>
																</figcaption>
															</figure>
															<div className="recommend_list_content">
																<h6>Cranial Nerve Nuclei and Columns</h6>
																<span className="name_label">Dr.Ashwani Kumar</span>
																<div className="rate_timer">
																	<span>
																		<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
																	</span>
																	<span>
																		<img src={Icons.Clock} alt="Star" className="img-fluid" /> 01:10:54
																	</span>
																	<span className="play_icn">
																		<img src={Icons.Play} alt="Play" className="img-fluid" />
																	</span>
																</div>
															</div>
														</div>
													</li>
												</ul>
											</div>
										</div>
									)
								}
								{
									query2.data && query2.data?.freevideo?.videos?.length != 0 &&
									packageStatus?.isTrialUser === false && packageStatus?.activePackageLength === 0 &&
									<div className="recommended_video_wrapper Free_videos_wrapper" onClick={handleShow}>
										<div className="subjects_header">
											<h6>Free Videos</h6>
											<div className="view_all_text d-flex align-items-center">
												<div className="main_paragraph">
													<p>Start your learning journey with free videos</p>
												</div>
												<div className="view_text">
													<Link to={`/view/all/video`}>
														<p><a href="/">View All</a></p>
													</Link>
												</div>
											</div>
										</div>

										<div className="recommend_video_details">
											<ul type="none" className="recommend_list">
												{query2.data && query2?.data?.freevideo?.videos.map((d, i) => (
													<li>
														<div className="recommend_list_main d-flex align-items-center">
															<figure className="user_img">
																<img src={d.thumbnail ? d.thumbnail : Images.defaultImg} alt="" className="img-fluid" />

																{d.purchaseStatus !== 0 && <figcaption className="free_tag">
																	<span>Pro</span>
																</figcaption>}
																{
																	d.purchaseStatus === 0 && (packageStatus?.isTrialUser === false && packageStatus?.activePackageLength === 0) &&
																	<figcaption className="free_tag">
																		<span>Free</span>
																	</figcaption>
																}
															</figure>
															<div className="recommend_list_content">
																<h6>{d?.title}</h6>
																<span className="name_label">{d?.author?.name}</span>
																<div className="rate_timer">
																	<span>
																		<img src={Icons.Star} alt="Star" className="img-fluid" />{d?.rating?.length > 1 ? d?.rating : d?.rating + '.0'}
																	</span>
																	{
																		parseInt(version?.actual) < 4 &&
																		<span>
																			<img src={Icons.Clock} alt="Clock" className="img-fluid" /> {`${getTime(d.video)}`}
																		</span>
																	}
																	{
																		parseInt(version?.actual) > 4 &&
																		<span>
																			<img src={Icons.Clock} alt="Clock" className="img-fluid" /> {`${getfreeVideoTime(d)}`}
																		</span>
																	}
																	<span className="play_icn">
																		<img src={Icons.Play} alt="Play" className="img-fluid" />
																	</span>
																</div>
															</div>
														</div>
													</li>
												))}
												{/* <li>
												<div className="recommend_list_main d-flex align-items-center">
													<figure className="user_img">
														<img src={Images.FreeVideoImg} alt="" className="img-fluid" />
														<figcaption className="free_tag">
															<span>Free</span>
														</figcaption>
													</figure>
													<div className="recommend_list_content">
														<h6>Cranial Nerve Nuclei and Columns</h6>
														<span className="name_label">Dr.Ashwani Kumar</span>
														<div className="rate_timer">
															<span>
																<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
															</span>
															<span>
																<img src={Icons.Clock} alt="Star" className="img-fluid" /> 01:10:54
															</span>
															<span className="play_icn">
																<img src={Icons.Play} alt="Play" className="img-fluid" />
															</span>
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="recommend_list_main d-flex align-items-center">
													<figure className="user_img">
														<img src={Images.FreeVideoImg} alt="" className="img-fluid" />
														<figcaption className="free_tag">
															<span>Free</span>
														</figcaption>
													</figure>
													<div className="recommend_list_content">
														<h6>Cranial Nerve Nuclei and Columns</h6>
														<span className="name_label">Dr.Ashwani Kumar</span>
														<div className="rate_timer">
															<span>
																<img src={Icons.Star} alt="Star" className="img-fluid" /> 5.0
															</span>
															<span>
																<img src={Icons.Clock} alt="Star" className="img-fluid" /> 01:10:54
															</span>
															<span className="play_icn">
																<img src={Icons.Play} alt="Play" className="img-fluid" />
															</span>
														</div>
													</div>
												</div>
											</li> */}
											</ul>
										</div>
									</div>
								}


								{/* <div className="subjects_wrapper Subject_selection_right_side"> */}
								{/* <div className="subjects_header">
									<h6>Move to other Subject</h6>
								</div> */}
								{/* <div className="all_subjects_name_wrapper"> */}
								{/* <ul type="none" className="subjects_child d-flex flex-wrap"> */}
								{/* <li className="active">
												<div className="subject_main_list d-flex align-itmes-center">
													<div className="subject_img_wrap d-flex align-items-center">
														<figure className="subject_img">
															<img src={Icons.Micro} alt="" className="img-fluid" />
														</figure>
														<div className="subject_details">
															<h6>Microbiology</h6>
															<p>Dr.Ashwani Kumar</p>
														</div>
													</div>
													<div className="progressbar_wraper d-flex align-items-center">
														<div className="progress_details">
															<span>40%</span>
															<div className="progress">
																<div className="progress-bar" style={{ width: "30%" }}></div>
															</div>
														</div>
														<div className="right_arrow">
															<img src={Icons.VideoArrow} alt="" className="img-fluid" />
														</div>
													</div>
												</div>
											</li>
											<li>
												<div className="subject_main_list d-flex align-itmes-center">
													<div className="subject_img_wrap d-flex align-items-center">
														<figure className="subject_img">
															<img src={Icons.Micro} alt="" className="img-fluid" />
														</figure>
														<div className="subject_details">
															<h6>Microbiology</h6>
															<p>Dr.Ashwani Kumar</p>
														</div>
													</div>
													<div className="progressbar_wraper d-flex align-items-center">
														<div className="progress_details">
															<span>40%</span>
															<div className="progress">
																<div className="progress-bar" style={{ width: "30%" }}></div>
															</div>
														</div>
														<div className="right_arrow">
															<img src={Icons.VideoArrow} alt="" className="img-fluid" />
														</div>
													</div>
												</div>
											</li> */}
								{/* <li>
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Microbiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>
												<div className="progressbar_wraper d-flex align-items-center">
													<div className="progress_details">
														<span>40%</span>
														<div className="progress">
															<div className="progress-bar" style={{ width: "30%" }}></div>
														</div>
													</div>
													<div className="right_arrow">
														<img src={Icons.VideoArrow} alt="" className="img-fluid" />
													</div>
												</div>
											</div>
										</li> */}
								{/* </ul> */}
								{/* </div> */}
								{/* </div> */}
							</div>
						</div>
						{/* <div className="col-lg-12">
					{
						(query1.data&&query1.data.layers.length==0||query1.data&&query1.data.layers[0].subLayers.length==0) &&query2.data&&query2.data.freevideo.videos.length==0 && <NoDataFound></NoDataFound>
					}
					</div> */}
					</div>
				</section>
			</div>
			<Modal
				show={show}
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
				className="video_modal"
				centered
				size="lg"
			>
				{/* <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content"> */}
				{/* <div className="modal-body"> */}
				<Modal.Body >
					<div className="play_back_video">
						{/* <img src={Icons.ModalWarning} alt="warning" className="img-fluid" /> */}
						<img src={Images.VideopopupImg} alt="warning" className="img-fluid" />
						{/* <p>Video Play back available only on Mobile App</p> */}
						<span className="modal_cross" data-dismiss="modal" onClick={handleClose}>
							<img src={Icons.ModalCross} alt="cross" className="img-fluid" />
						</span>
					</div>
				</Modal.Body>
				{/* </div> */}
				{/* </div> */}
				{/* </div> */}
			</Modal>

			<Modal
				show={proUserShow}
				onHide={ProUserHide}
				backdrop="static"
				className="detail_modal report_modal proUsers_modal"
				centered
			>
				<Modal.Header>
					<Modal.Title>
						<h4>Available for only Pro users</h4>
						<div className="cross_icon text-right">
							<img src={Icons.ModalCross} alt="" className="img-fluid" onClick={ProUserHide} />
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* <div className="account_option_wrapper"> */}
					<div className="account_header text-center">
						<img src={Icons.LockPro} alt="" className="img-fluid" />
						{/* <h6>Account Deleted!!</h6> */}
						<p>This content is available for pro users only. Click on View Plans to checkout suitable plans to access this course</p>
					</div>
					{/* </div> */}
				</Modal.Body>
				<Modal.Footer>
					<div className="rating_submit">
						<button type="button" className="btn btn_theme btn_border" onClick={ProUserHide}>Cancel</button>
						<button type="submit" className="btn btn_theme">View Plans</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default VideoLayer;